import IdentityBar from './components/IdentityBar';
import HeroSection from './components/HeroSection';
import ValuesSection from './components/ValuesSection';
import ContactFooter from './components/ContactFooter';

export default function Home() {
  return (
    <main
      className="min-h-screen w-full bg-background-50"
      style={{ fontFamily: 'var(--font-body)' }}
    >
      <IdentityBar />
      <HeroSection />
      <ValuesSection />
      <ContactFooter />
    </main>
  );
}